import { useEffect, useState } from 'react';

import { StoresProvider } from '@/common/components/StoresProvider/StoresProvider';
import { useDriveModifierStore } from '@/drive/stores/DriveModifierStore/DriveModifierStore';
import { DriveGlobalAccessTarget, DriveGlobalAccessType } from '@/security/types/AccessTarget';

import { DriveGlobalAccessModalStore } from '../DriveGlobalAccessModalStore';

import DriveGlobalAccessModalContent from './DriveGlobalAccessModalContent';

interface DriveGlobalAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  target: DriveGlobalAccessTarget;
  type: DriveGlobalAccessType;
  onSuccess?: () => void;
}

function DriveGlobalAccessModal(props: DriveGlobalAccessModalProps) {
  const { target, type, isOpen, onClose, onSuccess } = props;

  const driveModifierStore = useDriveModifierStore();

  const [driveAccessStore, setDriveAccessStore] = useState<Nullable<DriveGlobalAccessModalStore>>(null);

  useEffect(() => {
    setDriveAccessStore(isOpen && target ? new DriveGlobalAccessModalStore(target, type, driveModifierStore) : null);
  }, [isOpen]);

  if (!driveAccessStore) {
    return null;
  }

  return (
    <StoresProvider stores={{ driveAccessStore }}>
      <DriveGlobalAccessModalContent type={type} isOpen={isOpen} onClose={onClose} onSuccess={onSuccess} />
    </StoresProvider>
  );
}

export default DriveGlobalAccessModal;
